import { Context, useContext } from 'react';
import { StoreApi, useStore } from 'zustand';

/**
 * Creates a custom hook that allows components to access the store and select specific data from it.
 */
export function createUseStoreHook<T>(StoreContext: Context<StoreApi<T>>) {
  return function <K>(selector: (state: T) => K): K {
    const store = useContext(StoreContext);
    if (!store) {
      throw new Error(
        'Store is not available. Make sure to provide a valid StoreContext or fallbackStore.'
      );
    }
    return useStore(store, selector);
  };
}
